<template>
    <q-dialog v-model="modalZoom" transition-show="scale" transition-hide="scale" :maximized="$q.platform.is.mobile">
        <q-card content-class="product-zoom" class="modal-product-zoom">
            <div class="modal-close" @click="modalZoom=false">
                <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px"
                         height="10px"
                         viewBox="0 0 10 10"
                         enable-background="new 0 0 10 10"
                         xml:space="preserve">
                        <path
                            d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                    </svg>
                </span>
            </div>
            <q-card-section class="modal-content">
                <carousel ref="zoom" :items="images" :image="modalZoomImage" :options="options"
                          :show-navigation="showNavigation">
                    <template #slide="{ item }">
                        <div class="pinch-zoom-parent" style="height: 80vh; width: 100vw;">
                            <div class="pinch-zoom">
                                <img :src="item.image" alt=""/>
                            </div>
                        </div>
                    </template>
                </carousel>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import Carousel from "./../Carousel/Carousel";
import PinchZoom from 'pinch-zoom-js';
import Navigation from "../Carousel/Navigation";
import {mapState} from "vuex";

export default {
    name: 'ProductZoom',
    props: {
        images: {
            type: Array,
        }
    },
    components: {
        Navigation,
        Carousel,
    },
    data() {
        return {
            zoom: null,
            options: {
                allowTouchMove: false,
                loop: false,
                speed: 1,
                slidesPerView: 1,
            }
        }
    },
    watch: {
        modalZoom(val) {
            if (val) {
                this.updateZoom();
            }
        },
    },
    methods: {
        updateZoom() {
            let _this = this;

            this.$nextTick(function () {
                Array.from(document.querySelectorAll('.pinch-zoom')).forEach(function (el) {
                    _this.zoom = new PinchZoom(el, {});
                });
            });
        },
    },
    computed: {
        ...mapState('product', ['modalZoomImage']),
        modalZoom: {
            get() {
                return this.$store.state.product.modalZoom;
            },
            set(value) {
                if (value) {
                    this.$store.commit('product/showProductZoomModal');
                } else {
                    this.$store.commit('product/hideProductZoomModal');
                }
            }
        },
        showNavigation() {
            return this.images.length > 1;
        }
    },
}
</script>
